<template>
  <vs-card>
    <div slot="header">Consultas</div>

    <vs-table stripe :data="requests">
      <template slot="thead">
        <vs-th>Fecha de consulta</vs-th>
        <vs-th>Nombre otorgante</vs-th>
        <vs-th>Tipo de credito</vs-th>
        <vs-th>Importe del credito</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr v-for="(request, index) in data" :key="index">
          <vs-td>{{request.fechaConsulta}}</vs-td>
          <vs-td>{{request.nombreOtorgante}}</vs-td>
          <vs-td>{{request.tipoCredito}}</vs-td>
          <vs-td>{{request.importeCredito}}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vs-card>
</template>

<script>
export default {
  name: "ci-requests-table",
  props: ["requests"]
}
</script>

<style scoped>

</style>
